import { HttpContext } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ALLOW_ANONYMOUS } from '@delon/auth';
import { _HttpClient } from '@delon/theme';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-user-terms',
  templateUrl: 'user-terms.component.html',
  styleUrls: ['./user-terms.component.less'],
  standalone: true,
  imports: [NzModalModule]
})
export class UserTermsComponent implements OnInit {
  constructor(private readonly http: _HttpClient) {}

  visible = false;
  country = 'PH';

  open() {
    this.visible = true;
  }

  close() {
    this.visible = false;
  }

  ngOnInit() {
    this.loadCountry();
  }

  get companyNameUpperCase() {
    // if (this.country === 'MY') {
    //   return 'QNE OPTIMUM'
    // }
    // return 'QNE SOFTWARE';
    return 'QNE SOFTWARE'
  }

  get companyNameLowerCase() {
    // if (this.country === 'MY') {
    //   return 'QNE Optimum'
    // }
    // return 'QNE Software';
    return 'QNE Software'
  }

  loadCountry() {
    this.http
      .get(
        'https://ipinfo.io/json',
        {},
        {
          context: new HttpContext().set(ALLOW_ANONYMOUS, true)
        }
      )
      .subscribe({
        next: (res: any) => {
          this.country = res?.country;
        },
        error: () => {
          this.country = 'PH';
        }
      });
  }
}
